import { mapState, mapGetters, mapActions } from 'vuex'

export const appAuthComputed = {
    ...mapState('appAuth', {
        appSession: (state) => state.appSession,
    }),
    ...mapGetters('appAuth', ['appLoggedIn', 'updateCompanyInfo']),
}

export const appAuthMethods = mapActions('appAuth', [
    'appLogIn',
    'companyInfoExists',
])

export const authComputed = {
    ...mapState('auth', {
        currentSession: (state) => state.currentSession,
    }),
    ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', [
    'logIn',
    'logOut',
    'register',
    'resetPassword',
    'setUserActiveSection',
])

export const usersMethods = mapActions('users', [
    'fetchUsers',
    'createUpdateUsers',
    'deleteUsers',
    'changePassword',
    'updatePhotos',
    'fetchUsersDetail',
    'fetchUsersForOptions',
])

export const permsComputed = {
    ...mapState('perms', {
        cached: (state) => state.cached,
    }),
}

export const permsMethods = mapActions('perms', [
    'fetchPerms',
    'createUpdatePerms',
    'deletePerms',
    'fetchPermsDetail',
])

export const groupsComputed = {
    ...mapState('groups', {
        cached: (state) => state.cached,
    }),
}

export const groupsMethods = mapActions('groups', [
    'fetchGroups',
    'createUpdateGroups',
    'deleteGroups',
    'fetchGroupsDetail',
])

export const appSectionsComputed = {
    ...mapState('appSections', {
        cached: (state) => state.cached,
    }),
}

export const appSectionsMethods = mapActions('appSections', [
    'fetchAppSections',
    'createUpdateAppSections',
    'deleteAppSections',
    'fetchAppSectionsDetail',
])

export const companyInfoComputed = {
    ...mapState('companyInfo', {
        cached: (state) => state.cached,
    }),
}

export const companyInfoMethods = mapActions('companyInfo', [
    'fetchCompanyInfo',
    'createUpdateCompanyInfo',
    'setFileCompanyInfo',
])

export const locationsMethods = mapActions('company/locations', [
    'fetchLocations',
])

export const thirdpartyMethods = mapActions('company/thirdparty', [
    'createThirdparty',
    'updateThirdparty',
    'deleteThirdparty',
    'fetchThirdparties',
    'setThirdpartyFile',
    'fetchThirdPartyAssessments',
])

export const assessmentMethods = mapActions('assessment/assessment', [
    'fetchAssesments', 'createUpdateAssesment',
    'checkPasswordAssessment', 'fetchAssesmentTypes', 'deleteAssessment',
    'getPassword', 'getDepartments'
])

export const assessmentUserMethods = mapActions('assessment/assessmentUser', [
    'createUpdateAssesmentUser', 'fetchAssesmentUsers', 'deleteAssessmentUser',
    'massiveUserCreation', 'AssessmentUserThirdparties'
])
export const assessmentTotalPeople = mapActions('assessment/assessmentTotalPeople', [
    'fetchAssessmentTotalPeople'
])

export const organizationChartMethods = mapActions('assessment/organizationChart', [
    'fetchOrganizationCharts', 'createUpdateOrganizacionChart',
    'deleteOrganizationChart', 'fetchPositions', 'fetchAreas',
    'createUpdatePosition', 'createUpdateArea', 'fetchOrganizationChartsSelector'
])

export const questionPageMethods = mapActions('assessment/questionPagination', [
    'getQuestionPage'
])

export const assessmentRunSessionMethods = mapActions('assessment/assessmentRunSession', [
    'getRunSession', 'createUpdateRunSession', 'findCurrentRunSession',
    'cleanRunSession', 'fetchAssessmentRunSessionReports',
    'fetchAssessmentRunSessionIndividualReport',
    'fetchAssessmentRunSessionDemographicGeneral',
    'fetchAssessmentRunSessionReportsGeneral',
    'fetchAssessmentRunSessionDemographic', 'generateReports'
])

export const userAnswerMethods = mapActions('assessment/userAnswer', [
    'fetchUserAnswers', 'saveMultipleAnswers', 'deleteIndependentQuestion', 'deleteAllQuestion'
])

export const surveyMethods = mapActions('assessment/survey', [
    'fetchSurveys',
])

export const intraOccupationalReportMethods = mapActions(
    'report/intraOccupationalReport', [
        'createIntraOccupationalReport',
    ])

export const generateReportPdf = mapActions('report/generatePdf', [
    'generateReportPdf'
])
export const observations = mapActions('report/observations', [
    'observationIntralaboral', 'observationExtralaboral', 'observationStress',
    'observationDemographic', 'observationGeneralAandB'
])
export const evaluators = mapActions('assessment/evaluator', [
    'fetchEvaluators','manageEvaluator','managePermissionsEvaluator','getPermissionsEvaluator','deletePermissionsEvaluator'
])
export const intraOccupationalReportDetailMethods = mapActions(
    'report/intraOccupationalReportDetail', [
        'fetchIntraOccupationalReportDetails',
        'fetchIntraOccupationalReportDetailsAandBDominio',
        'fetchIntraOccupationalReportDetailsAandBDimensions',
        'fetchIntraOccupationalReportDetailsAandBGeneral',
    ])
export const stressReportDetailMethods = mapActions(
    'report/stressReportDetail', [
        'fetchStressReportDetailDimensionsAandB',
        'fetchStressReportDetailGeneralAandB',
    ])
export const outsideWorkReportDetailMethods = mapActions(
    'report/outsideWorkReportDetail', [
        'fetchOutsideWorkReportDetail',
        'fetchOutsideWorkReportDetailDimensionsAandB',
        'fetchOutsideWorkReportDetailGeneralAandB',
    ])